import React from 'react';
import { Platform, StyleSheet } from 'react-native';
import { type Edges, SafeAreaView } from 'react-native-safe-area-context';
import { Button, Modal, TextLinkify, theme, useResponsive } from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

// ─────────────────────────────────────────────────────────────────────────────

export const AccountDeletionSecondStep = (props: SecondStepProps) => {
  const { body, isDeletingAccount, requestAccountDeletion } = props;

  const { t } = useLocalizationContext();
  const { match } = useResponsive();

  return (
    <SafeAreaView edges={SAFE_AREA_EDGES}>
      <Modal.Headline>{t('account.delete.headline')}</Modal.Headline>

      <Modal.BodyText>
        <TextLinkify>{body}</TextLinkify>
      </Modal.BodyText>

      <Modal.Footer withoutTopBorder style={styles.footer}>
        <Button
          testID="account.delete.confirm"
          size={match(['medium', 'large'])}
          style={styles.deleteAccountCTA}
          isLoading={isDeletingAccount}
          onPress={requestAccountDeletion}
        >
          {t('account.delete.confirm')}
        </Button>
      </Modal.Footer>
    </SafeAreaView>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SAFE_AREA_EDGES: Edges = Platform.select({
  android: ['bottom'],
  default: [],
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  deleteAccountCTA: {
    marginTop: theme.spacing['4'],
  },
  footer: {
    marginBottom: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type SecondStepProps = Readonly<{
  body: string;
  isDeletingAccount: boolean;
  requestAccountDeletion: () => void;
}>;
